/* eslint-disable */
// @ts-nocheck

/* eslint-enable prettier/prettier */
/* eslint-enable @typescript-eslint/no-unused-vars */
/* eslint-enable import/no-unresolved */

import React, { useState, forwardRef } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Button } from "@material-ui/core";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";

import AccessTimeIcon from "@material-ui/icons/AccessTime";
import ThumbUpIcon from "@material-ui/icons/ThumbUp";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLongArrowAltUp } from "@fortawesome/free-solid-svg-icons";
import Tippy from "@tippyjs/react";

import { selectPublicQuestionsLiveOnly } from "@untyped-store/selectors/activeEvent";
import "./override.css";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: `0 0 ${theme.spacing(1)}px 0`,
    color: "#717171",
  },
  groupIcons: {
    paddingRight: 2,
  },
  fs12rem: {
    fontSize: "1.2rem",
  },
  visibilityIcon: {
    color: "#000000",
    fontSize: "2rem !important",
  },
  toggleIconSelected: {
    color: "#FFFF",
  },
  toggleIconUnselected: {
    color: "#424242",
  },
  toggleButtons: {
    padding: 4,
    textAlign: "start",
    marginBlock: "10px",
  },
  endButton: {
    padding: 4,
    textAlign: "end",
    marginBlock: "10px",
  },
  btn: {
    color: "#000000",
    textTransform: "none",
    fontSize: "1.2rem",
    border: "1px solid rgba(0, 0, 0, 0.15)",
    padding: "7px 12px",
    maxHeight: 31,
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.1rem",
    },
  },
  focusSelected: {
    "&:focus": {
      outlineColor: "#FFFF",
      outlineWidth: "3px",
      outlineStyle: "solid",
      outlineOffset: "-6px",
    },
  },
  focusUnselected: {
    "&:focus": {
      outlineColor: "#000000",
      outlineWidth: "3px",
      outlineStyle: "solid",
      outlineOffset: "-6px",
    },
  },
  activeBtn: {
    backgroundColor: "rgba(78, 255, 87, 0.212)",
  },
  inactiveBtn: {
    backgroundColor: "rgba(255, 168, 168, 0.212)",
  },
}));

const TooltipToggleButton = forwardRef((props, ref) => {
  const { TooltipProps, ...rest } = props;

  return (
    <Tippy {...TooltipProps}>
      <ToggleButton ref={ref} {...rest} disableRipple />
    </Tippy>
  );
});

TooltipToggleButton.displayName = "TooltipToggleButton";

function ManagerQaList({ sortByVotes, hideAnswered, toggleHideAnswered }) {
  const classes = useStyles();
  const [alignment, setAlignment] = useState<"time" | "vote">("time");
  const publicQuestionsLiveOnly = useSelector(selectPublicQuestionsLiveOnly);

  const handleAlignment = (event, newAlignment: "time" | "vote") => {
    if (newAlignment !== null) {
      setAlignment(newAlignment);
      const value = newAlignment === "vote";
      sortByVotes(value);
    }
  };

  const handleHideClick = () => {
    toggleHideAnswered();
  };

  const arrowIconSelectedClasses = `${classes.fs12rem} ${classes.toggleIconSelected}`;
  const arrowIconUnselectedClasses = `${classes.fs12rem} ${classes.toggleIconUnselected}`;

  const groupIconSelectedClasses = `${classes.groupIcons} ${classes.toggleIconSelected}`;
  const groupIconUnselectedClasses = `${classes.groupIcons} ${classes.toggleIconUnselected}`;

  return (
    <Grid
      id="qa-manager-list"
      container
      aria-label={I18n.t("frontend.question_control")}
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      className={classes.root}
    >
      <Grid item xs={4} className={classes.toggleButtons}>
        <ToggleButtonGroup
          value={alignment}
          exclusive
          onChange={handleAlignment}
          size="small"
        >
          <TooltipToggleButton
            value="time"
            className={`${alignment === "time" ? classes.focusSelected : classes.focusUnselected}`}
            aria-label={I18n.t("questions.sort_by_time")}
            TooltipProps={{
              content: I18n.t("questions.sort_by_time"),
              className: classes.fs12rem,
            }}
          >
            <AccessTimeIcon
              className={
                alignment === "time"
                  ? groupIconSelectedClasses
                  : groupIconUnselectedClasses
              }
            />
            <FontAwesomeIcon
              icon={faLongArrowAltUp}
              className={
                alignment === "time"
                  ? arrowIconSelectedClasses
                  : arrowIconUnselectedClasses
              }
            />
          </TooltipToggleButton>
          <TooltipToggleButton
            value="vote"
            className={`${alignment === "vote" ? classes.focusSelected : classes.focusUnselected}`}
            aria-label={I18n.t("questions.sort_by_votes")}
            TooltipProps={{
              content: I18n.t("questions.sort_by_votes"),
              className: classes.fs12rem,
            }}
          >
            <ThumbUpIcon
              className={
                alignment === "vote"
                  ? groupIconSelectedClasses
                  : groupIconUnselectedClasses
              }
            />
            <FontAwesomeIcon
              icon={faLongArrowAltUp}
              className={
                alignment === "vote"
                  ? arrowIconSelectedClasses
                  : arrowIconUnselectedClasses
              }
            />
          </TooltipToggleButton>
        </ToggleButtonGroup>
      </Grid>
      {!publicQuestionsLiveOnly && (
        <Grid item xs={8} className={classes.endButton}>
          <Tippy
            content={I18n.t("questions.toggle_answered")}
            delay={2000}
            className={classes.fs12rem}
          >
            <Button
              variant="outlined"
              className={`${`${classes.btn} ${classes.focusUnselected} answered-questions`} ${hideAnswered ? classes.activeBtn : classes.inactiveBtn}`}
              startIcon={
                hideAnswered ? (
                  <VisibilityIcon
                    className={classes.visibilityIcon}
                    fontSize="inherit"
                  />
                ) : (
                  <VisibilityOffIcon
                    className={classes.visibilityIcon}
                    fontSize="inherit"
                  />
                )
              }
              onClick={handleHideClick}
              disableRipple
            >
              {hideAnswered
                ? I18n.t("questions.show_answered")
                : I18n.t("questions.hide_answered")}
            </Button>
          </Tippy>
        </Grid>
      )}
    </Grid>
  );
}

ManagerQaList.propTypes = {
  sortByVotes: PropTypes.func,
  hideAnswered: PropTypes.bool,
  toggleHideAnswered: PropTypes.func,
};

TooltipToggleButton.propTypes = {
  TooltipProps: PropTypes.object,
};

export default ManagerQaList;
